import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Realization = () => {
  const { id, actionId, worker } = useParams();
  const [selectedPosition, setSelectedPosition] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [products, setProducts] = useState([]);
  const [value, setValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [startDateTimeDisplay, setStartDateTimeDisplay] = useState(null);
  const [showStartField, setShowStartField] = useState(false);
  const [showEndField, setShowEndField] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  function roundToDecimalPlaces(number, decimalPlaces) {
    if (isNaN(number)) return NaN;
    return Number(number.toFixed(decimalPlaces));
  }

  function printLabel() {
    window.open(
      "/printlabel/" + id + "/" + actionId + "/" + worker,
      "CC MES - wydruk etykiety",
      "height=800,width=600"
    );
  }

  const handleIncrement = () => {
    if (value + 1 <= maxValue) {
      setValue(value + 1);
      const updatedMaterials = materials.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * (value + 1), 4),
      }));

      setMaterials(updatedMaterials);

      const updatedProducts = products.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * (value + 1), 4),
      }));

      setProducts(updatedProducts);
    }
  };

  const handleDecrement = () => {
    if (value - 1 >= 0) {
      setValue(value - 1);
      const updatedMaterials = materials.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * (value - 1), 4),
      }));

      setMaterials(updatedMaterials);

      const updatedProducts = products.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * (value - 1), 4),
      }));

      setProducts(updatedProducts);
    }
  };

  const handleValueChange = (newValue) => {
    if (newValue <= maxValue && newValue >= 0) {
      setValue(newValue);

      const updatedMaterials = materials.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * newValue, 4),
      }));

      setMaterials(updatedMaterials);

      const updatedProducts = products.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(obj.unitQuantity * newValue, 4),
      }));

      setProducts(updatedProducts);
    }
  };

  const startWork = () => {
    if (startDateTime !== null) {
      setLoading(true);
      axios
        .post(
          `http://83.144.125.123:5222/Document/StartRealization?originId=${actionId}&operationStart=${startDateTime}&worker=${worker}`,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          GetData();
        })
        .catch((error) => {
          setLoading(false);
          console.log("API ERROR!");
          console.log(error);
          console.log(error?.response?.data);
          alert(
            "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/StartRealization. Skontaktuj się z administratorem systemu."
          );
        });
    }
  };

  const cancelWork = () => {
    if (startDateTime !== null) {
      setLoading(true);
      axios
        .post(
          `http://83.144.125.123:5222/Document/CancelRealization?originId=${actionId}&operationStart=${startDateTime}&worker=${worker}`,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          GetData();
        })
        .catch((error) => {
          setLoading(false);
          console.log("API ERROR!");
          console.log(error);
          console.log(error?.response?.data);
          alert(
            "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/CancelRealization. Skontaktuj się z administratorem systemu."
          );
        });
    }
  };

  function sendRealization(actionOnFinish) {
    if (endDateTime >= startDateTime && endDateTime !== null && value > 0) {
      setLoading(true);
      const materialsAndProducts = materials.concat(products);

      const updatedMaterialsAndProducts = materialsAndProducts.map((obj) => ({
        ...obj,
        quantity: obj.realization,
      }));

      axios
        .post(
          `http://83.144.125.123:5222/Document/AddRealization?originId=${actionId}&quantity=${value}&operationStart=${startDateTime}&operationEnd=${endDateTime}&worker=${worker}`,
          JSON.stringify(updatedMaterialsAndProducts),
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          setLoading(false);

          if (actionOnFinish === 0) {
            setShowSuccess(true);
            GetData();
          } else if (actionOnFinish === 1) {
            history.push("/" + worker);
            history.go();
          } else if (actionOnFinish === 2) {
            history.push("/");
            history.go();
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("API ERROR!");
          console.log(error);
          console.log(error?.response?.data);
          alert(
            "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/AddRealization. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
              error?.response?.data
          );
        });
    } else {
      if (endDateTime === null) {
        alert("Nie uzupełniono daty zakończenia operacji");
      }

      if (endDateTime < startDateTime) {
        alert("Data zakończenia musi być późniejsza niż data rozpoczęcia");
      }

      if (value <= 0) {
        alert("Podano błędną ilość");
      }
    }
  }

  const addRealization = () => {
    sendRealization(0);
  };

  const addRealizationAndSearch = () => {
    sendRealization(1);
  };

  const addRealizationAndLogout = () => {
    sendRealization(2);
  };

  const GetData = async () => {
    try {
      setLoading(true);

      const getOperationMaterials = await axios.get(
        "http://83.144.125.123:5222/Document/GetOperationMaterials",
        {
          params: {
            originId: actionId,
          },
        }
      );

      const updatedMaterials = getOperationMaterials.data.map((obj) => {
        return {
          ...obj,
          realization: 0,
        };
      });

      setMaterials(updatedMaterials);

      const getOperationProducts = await axios.get(
        "http://83.144.125.123:5222/Document/GetOperationProducts",
        {
          params: {
            originId: actionId,
          },
        }
      );

      const updatedProducts = getOperationProducts.data.map((obj) => {
        return {
          ...obj,
          realization: 0,
        };
      });

      setProducts(updatedProducts);

      const getOperationDetails = await axios.get(
        "http://83.144.125.123:5222/Document/GetOperationDetails",
        {
          params: {
            worker: worker,
            originId: actionId,
          },
        }
      );

      setSelectedPosition(getOperationDetails.data);

      let maximumQuantity = 0;
      getOperationMaterials.data.forEach((item) => {
        if (maximumQuantity !== -1) {
          let toProduceQuantity = parseFloat(
            (item?.available / item?.unitQuantity).toFixed(4)
          );
          let materialQuantityLeft = parseFloat(
            (item?.quantity - item?.realized).toFixed(4)
          );

          console.log(
            item?.code + " toProduceQuantity_1: " + toProduceQuantity
          );

          console.log(item?.code + " quantityLeft: " + materialQuantityLeft);

          if (toProduceQuantity > materialQuantityLeft) {
            toProduceQuantity = parseFloat(
              (materialQuantityLeft / item?.unitQuantity).toFixed(4)
            );
          }

          console.log(
            item?.code + " toProduceQuantity_2: " + toProduceQuantity
          );

          if (toProduceQuantity === 0) {
            maximumQuantity = -1;
          } else {
            if (maximumQuantity === 0 || toProduceQuantity < maximumQuantity) {
              maximumQuantity = toProduceQuantity;
            }
          }

          console.log(item?.code + " maximumQuantity: " + maximumQuantity);
        }
      });

      if (maximumQuantity === -1) {
        setMaxValue(0);
        setValue(0);
        maximumQuantity = 0;
      } else {
        maximumQuantity = Math.floor(maximumQuantity);
        let quantityLeft =
          getOperationDetails.data.quantity - getOperationDetails.data.realized;

        if (maximumQuantity > quantityLeft) {
          setMaxValue(quantityLeft);
          setValue(quantityLeft);
          maximumQuantity = quantityLeft;
        } else {
          setMaxValue(maximumQuantity);
          setValue(maximumQuantity);
        }
      }

      const updatedMaterialsFirst = getOperationMaterials.data.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(
          obj.unitQuantity * maximumQuantity,
          4
        ),
      }));

      setMaterials(updatedMaterialsFirst);

      const updatedProductsFirst = getOperationProducts.data.map((obj) => ({
        ...obj,
        realization: roundToDecimalPlaces(
          obj.unitQuantity * maximumQuantity,
          4
        ),
      }));

      setProducts(updatedProductsFirst);

      const currentDatetime = new Date();
      const dateNow = new Date(
        currentDatetime.setHours(currentDatetime.getHours() + 2)
      )
        .toISOString()
        .slice(0, 16);

      const currentDatetimePlusMinute = new Date(
        currentDatetime.getTime() + 60000
      );

      const dateNowToEndOperation = currentDatetimePlusMinute
        .toISOString()
        .slice(0, 16);

      if (getOperationDetails.data.operationStart !== "0001-01-01T00:00:00") {
        setShowStartField(false);
        setShowEndField(true);
        setStartDateTime(getOperationDetails.data.operationStart);
        setEndDateTime(dateNowToEndOperation);
      } else {
        if (
          getOperationDetails.data.realized !==
          getOperationDetails.data.quantity
        ) {
          setShowStartField(true);
        }
        setShowEndField(false);
        setStartDateTime(dateNow);
        setEndDateTime(getOperationDetails.data.operationEnd);
      }

      setStartDateTimeDisplay(
        new Date(getOperationDetails.data.operationStart)
      );
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const goBack = () => {
    history.push("/operations/" + id + "/" + worker);
    history.go();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    GetData();
  }, []);

  useEffect(() => {
    const handleBrowserBack = () => {
      history.push("/" + worker);
      history.go();
    };

    // Add the event listener for the browser's back button
    window.addEventListener("popstate", handleBrowserBack);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, [history]);

  const optionsMaterials = {
    pageSize: -1,
    paging: false,
    search: false,
    rowStyle: (rowData) => {
      if (rowData.available === 0) {
        return { backgroundColor: "#ff5050" };
      } else if (rowData.available < rowData.quantity - rowData.realized) {
        // Customize the background color for rows where age is 25
        return { backgroundColor: "#fafa50" };
      }
      // Default style for other rows
      return {};
    },
  };

  const optionsProducts = {
    pageSize: -1,
    paging: false,
    search: false,
  };

  const handleClose = () => {
    setShowSuccess(false);
  };

  return (
    <Layout>
      <div className="positions-container">
        {showSuccess && (
          <Snackbar
            open={true}
            autoHideDuration={5000}
            onClick={handleClose}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert elevation={6} variant="filled" severity="success">
              Meldunek wykonany pomyślnie!
            </MuiAlert>
          </Snackbar>
        )}
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={goBack}
        >
          Powrót
        </Button>
        <div className="section">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Pracownik</b>
                </TableCell>
                <TableCell>{worker}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Zlecenie</b>
                </TableCell>
                <TableCell>
                  {selectedPosition.documentNumber} (poz. ZP:{" "}
                  {selectedPosition.originNo})
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Operacja</b>
                </TableCell>
                <TableCell>
                  {selectedPosition.code} {selectedPosition.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Postęp</b>
                </TableCell>
                <TableCell>
                  {selectedPosition.realized}/{selectedPosition.quantity}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className="section">
          <Button
            variant="contained"
            color="primary"
            className="largeButton"
            onClick={printLabel}
            title="Drukuj etykietę"
          >
            <PrintIcon />
          </Button>
        </div>
        <div>
          <div className="section">
            {showEndField && (
              <Button variant="contained" color="warning" onClick={cancelWork}>
                Anuluj
              </Button>
            )}
          </div>
          <div>
            <div className="section">
              {showEndField && (
                <div>
                  <b>Podaj ilość:</b>
                  <br />
                  <br />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDecrement}
                    className="largeButton"
                  >
                    -
                  </Button>
                  <div className="numberInput">
                    <TextField
                      type="number"
                      value={value}
                      onChange={(e) =>
                        handleValueChange(Number(e.target.value))
                      }
                      inputProps={{ min: 0, max: value }}
                    />
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleIncrement}
                    className="largeButton"
                  >
                    +
                  </Button>
                </div>
              )}
              <div className="sectionRow">
                {showStartField && (
                  <div>
                    <div className="dateTimePicker">
                      <TextField
                        type="datetime-local"
                        defaultValue={startDateTime}
                        value={startDateTime}
                        onChange={(e) => setStartDateTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                    <div className="largeButtonSection">
                      <Button
                        variant="contained"
                        color="primary"
                        className="largeButtonJob"
                        onClick={startWork}
                      >
                        Rozpocznij
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              <div className="sectionRow">
                {showEndField && (
                  <div>
                    <div className="jobButton">
                      <b>
                        Rozpoczęcie:{" "}
                        {startDateTimeDisplay.toLocaleString("pl-PL", {
                          timeZone: "Europe/Warsaw",
                          hour12: false,
                        })}
                      </b>
                      <br /> <br />
                    </div>
                    <div className="dateTimePicker">
                      <TextField
                        type="datetime-local"
                        defaultValue={endDateTime}
                        value={endDateTime}
                        onChange={(e) => setEndDateTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                    <div className="largeButtonSection">
                      <Button
                        variant="contained"
                        color="primary"
                        className="largeButtonJob"
                        onClick={addRealization}
                      >
                        Zakończ
                      </Button>
                    </div>
                    <div className="largeButtonSection">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={addRealizationAndSearch}
                      >
                        Zakończ i SZUKAJ NASTĘPNEJ
                      </Button>
                    </div>
                    <div className="largeButtonSection">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={addRealizationAndLogout}
                      >
                        Zakończ i wyloguj
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="datatable">
            <MaterialTable
              columns={[
                {
                  title: "Kod towaru",
                  field: "code",
                  cellStyle: (rowData) => ({
                    fontWeight: "bold",
                  }),
                  editable: "never",
                },
                { title: "Nazwa towaru", field: "name", editable: "never" },
                { title: "Jm", field: "unitCode", editable: "never" },
                { title: "Ilość", field: "quantity", editable: "never" },
                {
                  title: "Zrealizowano",
                  field: "realized",
                  cellStyle: (rowData) => ({
                    fontWeight: "bold",
                  }),
                  editable: "never",
                },
                {
                  title: "Ilość dostępna",
                  field: "available",
                  editable: "never",
                },
                {
                  title: "Ilość z technologii",
                  field: "unitQuantity",
                  editable: "never",
                },
              ]}
              options={optionsMaterials}
              data={materials}
              title="Materiały"
            />
          </div>

          <div className="datatable">
            <MaterialTable
              columns={[
                {
                  title: "Kod towaru",
                  field: "code",
                  cellStyle: (rowData) => ({
                    fontWeight: "bold",
                  }),
                  editable: "never",
                },
                { title: "Nazwa towaru", field: "name", editable: "never" },
                { title: "Jm", field: "unitCode", editable: "never" },
                { title: "Ilość", field: "quantity", editable: "never" },
                {
                  title: "Zrealizowano",
                  field: "realized",
                  cellStyle: (rowData) => ({
                    fontWeight: "bold",
                  }),
                  editable: "never",
                },
                {
                  title: "Ilość dostępna",
                  field: "available",
                  editable: "never",
                },
                {
                  title: "Ilość z technologii",
                  field: "unitQuantity",
                  editable: "never",
                },
              ]}
              options={optionsProducts}
              data={products}
              title="Wyroby"
            />
          </div>
        </div>
      </div>
      <br />
      <small className="rightsText">
        © 2023 — Aplikacja{" "}
        <a
          href="https://www.center.pl/"
          target={"_blank"}
          className="clearLink"
        >
          Computer Center
        </a>
        . Wszelkie prawa zastrzeżone
      </small>
    </Layout>
  );
};

export default Realization;
